import type { Song } from "./types";
import { twinkleTwinkle } from "./data/twinkle-twinkle";
import { losPollitos } from "./data/los-pollitos";
import { maryHadALittleLamb } from "./data/mary-had-a-little-lamb";
import { frereJacques } from "./data/frere-jacques";
import { odeToJoy } from "./data/ode-to-joy";
import { londonBridge } from "./data/london-bridge";
import { rowYourBoat } from "./data/row-your-boat";
import { itsyBitsySpider } from "./data/itsy-bitsy-spider";
import { oldMacdonald } from "./data/old-macdonald";
import { happyBirthday } from "./data/happy-birthday";

/** The 10 MVP songs (all in the public domain). */
export const SONGS: readonly Song[] = [
  twinkleTwinkle,
  losPollitos,
  maryHadALittleLamb,
  frereJacques,
  odeToJoy,
  londonBridge,
  rowYourBoat,
  itsyBitsySpider,
  oldMacdonald,
  happyBirthday,
];

export function getSong(id: string): Song | undefined {
  return SONGS.find((song) => song.id === id);
}
